import { Observable, of } from 'rxjs';

import { createFlashMessage } from '../components/Flash/redux';
import { FlashMessages } from '../components/Flash/redux/flash-messages';
import { ChallengeFiles } from '../redux/prop-types';

import { MAX_PAYLOAD_SIZE } from '../../../config/response-size-limit';

interface StandardizeRequestBodyArgs {
  id: string;
  challengeFiles: ChallengeFiles;
  challengeType: number;
}

interface File {
  contents: string;
  ext: string;
  history: string[];
  key: string;
  name: string;
}

interface Body {
  id: string;
  files?: File[];
  challengeType: number;
}

export function standardizeRequestBody({
  id,
  challengeFiles = [],
  challengeType
}: StandardizeRequestBodyArgs): Body {
  return {
    id,
    files: challengeFiles?.map(({ fileKey, contents, ext, name, history }) => {
      return {
        contents,
        ext,
        history,
        key: fileKey,
        name
      };
    }),
    challengeType
  };
}

export function getStringSizeInBytes(str: unknown = ''): number {
  const stringSizeInBytes = new Blob([JSON.stringify(str)]).size;

  return stringSizeInBytes;
}

export function bodySizeFits(bodySizeInBytes: number): boolean {
  return bodySizeInBytes <= MAX_PAYLOAD_SIZE;
}

/**
 * Valida o tamanho do body antes do envio ao servidor.
 *
 * @param body - Objeto que será serializado e enviado como payload
 * @returns null se a validação passar, ou um Observable com flash message de erro
 */
export function validateBodySize(
  body: Record<string, unknown>
): Observable<unknown> | null {
  const bodySizeInBytes = getStringSizeInBytes(body);
  if (!bodySizeFits(bodySizeInBytes)) {
    return of(
      createFlashMessage({
        type: 'danger',
        message: FlashMessages.ChallengeSubmitTooBig,
        variables: {
          'max-size': MAX_PAYLOAD_SIZE,
          'user-size': bodySizeInBytes,
          dismissible: true
        }
      })
    );
  }
  return null;
}
